import React, { ReactElement, ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import classNames from 'classnames';

import styles from './Toggle.module.scss';

export interface ToggleProps {
    hiddenChild: ReactNode;
    children?: ReactNode;
    customClassList?: {
        Toggle?: string;
        More?: string;
        Open?: string;
        Content?: string;
    };
    opener?: string | ReactElement;
    closer?: string | ReactElement;
    icon?: ReactElement;
    iconPosition?: 'before' | 'after';
    initiallyOpen?: boolean;
    hideInitialChildOnOpen?: boolean;
    onClick?: (currentState: boolean) => void;
}

const Toggle: React.FC<React.PropsWithChildren<ToggleProps>> = ({
    hiddenChild,
    hideInitialChildOnOpen = false,
    initiallyOpen = false,
    icon = '',
    iconPosition = 'after',
    onClick,
    customClassList,
    children,
    opener,
    closer,
}) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(initiallyOpen);

    const openCloseHandler = () => {
        setOpen((open) => !open);
        onClick?.(open);
    };
    const button = (
        <button
            className={classNames(styles.More, customClassList?.More)}
            onClick={openCloseHandler}
        >
            {open
                ? closer ?? t('TRANS-show-less')
                : opener ?? t('TRANS-show-more')}
            {icon}
        </button>
    );
    return (
        <div
            className={classNames(
                styles.Toggle,
                customClassList?.Toggle,
                open ? customClassList?.Open : ''
            )}
        >
            {iconPosition === 'before' && button}
            <div className={customClassList?.Content}>
                {(!open || (open && !hideInitialChildOnOpen)) && children}
                {open && hiddenChild}
            </div>
            {iconPosition === 'after' && button}
        </div>
    );
};
export default Toggle;
